var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMomViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 2.33325H12.25V3.49992H6.41667V2.33325ZM6.41667 4.66659H9.91667V5.83325H6.41667V4.66659ZM6.41667 8.16659H12.25V9.33325H6.41667V8.16659ZM6.41667 10.4999H9.91667V11.6666H6.41667V10.4999ZM1.75 2.33325H5.25V5.83325H1.75V2.33325ZM2.91667 3.49992V4.66659H4.08333V3.49992H2.91667ZM1.75 8.16659H5.25V11.6666H1.75V8.16659ZM2.91667 9.33325V10.4999H4.08333V9.33325H2.91667Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMomViewIcon);
export default __webpack_public_path__ + "static/media/MOMViewIcon.038b4cc4b4fffbe015b82cf4799983f0.svg";
export { ForwardRef as ReactComponent };